export default {
  namespaced: true,
  distribution_list: {
    title: "distribution list",
    sidebar: {
      list_name: "name",
      users: "users",
      email: "emails",
    },
    table_distribution: {
      title: "list",
      name: "name",
      emails: "emails",
      noemails: "no emails",
      successful_creation: "Distribution list created successfully",
      error_creation: "Error creating distribution list",
      successful_edit: "Distribution list updated successfully",
      error_edit: "Error updating distribution list",
      successful_delete: "Distribution list deleted successfully",
      error_delete: "Error deleting distribution list",
      users_count: 'number of users',
      emails_count: 'number of emails',
    }
  }
};
